<template>
  <div
    :class="{'editable-field':true,[form.name]:true}"
    @click="startEditing"
  >
    <strong :class="{'title-name':form.title === 'Дата рождения:'}">{{form.title}} </strong>

    <div class="content-text" v-if="!isEditing" @click="startEditing">
      <p>{{form.value}}</p>
    </div>

    <div class="edit-form" v-if="isEditing">
      <div class="input-wrapper">
        <input
          ref="inputField"
          type="text"
          v-model="newValue.value"
          @keyup.enter="saveForm"
          @keyup.esc="closeForm"
        />
      </div>
      <div class="form-edit-btn" @click.stop="saveForm" title="Сохранить">
        <font-awesome-icon class="icon save" icon="fa-solid fa-floppy-disk" />
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick, ref } from 'vue';
import { useStore } from 'vuex'

export default {
  name:'my-input-form',
  props: ["form"],
  setup(props) {
    const store = useStore()
    const isEditing = ref(false);
    const newValue = ref('')
    const formRef = ref(null);
    const inputField = ref(null);

    const startEditing = () => {
      if(!newValue.value){
        newValue.value = ref(props.form.value)
      }
      isEditing.value = true;
      nextTick(() => {
        inputField.value?.focus()
        inputField.value?.select?.()
      })
    };

    const closeForm = () => {
      isEditing.value = false;
    }

    const saveForm = () => {
      const newForm = {
        id: props.form.id,
        [props.form.name]: newValue.value.value,
      };
      store.dispatch('apiStorage/updateItem',{model:props.form.model,form:newForm})
      isEditing.value = false;
    };

    const handleOutsideClick = (event) => {
      if (isEditing.value && !event.target.closest('.editable-field') && !event.target.closest('.content-text')) {
        isEditing.value = false
      }
      if (isEditing.value && event.target.closest('.save')) {
        saveForm()
      }
    };
    window.addEventListener('click', handleOutsideClick);

    return {
      newValue,
      closeForm,
      isEditing,
      startEditing,
      saveForm,
      formRef,
      inputField,
    };
  },
};
</script>

<style scoped>
.editable-field {
  display: flex;
  align-items: center;
  min-height: 30px;
  cursor: text;
}

.edit-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.content-text {
  width: 100%;
  display: flex;
  align-content: center;
  align-items: center;
}

.content-text p {
  margin: 0;
  padding: 2px 6px;
  border: 1px solid transparent;
  border-radius: 4px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.content-text:hover p {
  background-color: #f3f6fb;
  border-color: #d7dce2;
}

.title-name {
  min-width: 132px;
}

.input-wrapper {
  flex: 1;
}

input {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #d7dce2;
  padding: 4px 8px;
  font-size: 14px;
  color: #1f2937;
  background: #fff;
  box-sizing: border-box;
}

input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.12);
}

.form-edit-btn {
  display: flex;
  margin-left: 6px;
  cursor: pointer;
}

.icon {
  border-radius: 4px;
  background-color: #eef2ff;
  color: #007bff;
  padding: 4px;
  width: 18px;
  height: 18px;
}

.save {
  background-color: #16a34a;
  color: #fff;
}

.save:hover {
  background-color: #128a3f;
}
</style>
